import { createUniversalRoute } from "../../utils/createUniversalRoute";
import { blogRoutes } from "../RebrandBlogLayout/routes";

export const routes = [
  {
    path: "/rebrand-e2e-tests/:item?",
    name: "RebrandE2eTests",
  },
  {
    path: "/blog",
    name: "RebrandBlogLayout",
    routes: blogRoutes,
  },
  {
    path: "/for-sale/:postcodeSector/:roadName/:dealExternalId/enquiry",
    name: "PropertyEnquiry",
  },
  {
    path: "/for-sale/:postcodeSector/:roadName/:dealExternalId",
    name: "RebrandIndividualPropertyPage",
  },
  {
    path: "/:item?",
    name: "RebrandPage",
  },
];

// TODO: Add a rebranded error handler here
export const rebrandRoutes = routes.map((route) =>
  createUniversalRoute(route, (e) => JSON.stringify(e)),
);
